import { api } from "./api";

export interface EggStockRow {
  date: string;
  production_trays: number;
  production_eggs: number;
  sales_trays: number;
  sales_eggs: number;
  broken_eggs: number;
  avg_price_per_egg: number;
  sale_amount: number;
  cum_production_trays: number;
  cum_sales_trays: number;
  stock_trays: number;
}

export interface EggStockReport {
  rows: EggStockRow[];
}

export const eggStockReportService = {
  getReport: (from?: string, to?: string): Promise<EggStockReport> => {
    const params = new URLSearchParams();
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    const qs = params.toString();
    return api
      .get(`/reports/egg-stock${qs ? `?${qs}` : ""}`)
      .then((r) => r.data as EggStockReport);
  },
};
